import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CheckboxSimple from "./CheckboxSimple";
import Gender from "./Gender";
import Price from "./Price";
import CheckboxLabel from "./CheckboxLabel";
import { getPropByLanguage } from "../../../../../utils/Language";
import { useApp } from "../../../../../contexts";
import { useMemo } from "react";

function FilterEarner(props) {
  const { language, T: t } = useApp();
  const propLang = getPropByLanguage(language);

  const { setFilterData, filterData, breedOptions, rankOptions } = props;

  const [breedOptionLocals, $breedOptionLocals] = useState([]);
  const [rankOptionLocals, $rankOptionLocals] = useState([]);

  const [genderOptions, $genderOptions] = useState([
    { value: "1", title: "Male" },
    { value: "0", title: "Female" },
    { value: "2", title: "N/A" },
  ]);
  const [isMintNftOptions, $isMintNftOptions] = useState([
    { value: "1", title: "Non NFT" },
    { value: "2", title: "NFT" },
  ]);
  const artTypeOptions = useMemo(() => {
    return [
      { value: "", title: t("All") },
      { value: "photo", title: t("Photo Art")},
      { value: "motion", title: t("Motion Art") },
    ]
  }, [language]);
  // console.log("filterData", filterData);
  const [rankCode, $rankCode] = useState(filterData?.rankCode || []);
  // const [nftCatIds, $nftCatIds] = useState(filterData?.nftCatIds || []);
  const [breeds, $breeds] = useState(filterData?.breeds || []);
  const [genders, $genders] = useState(filterData?.genders || []);
  const [tagNFT, $tagNFT] = useState(filterData?.tagNFT || []);
  const [priceFrom, $priceFrom] = useState(filterData?.priceFrom);
  const [priceTo, $priceTo] = useState(filterData?.priceTo);
  const [isMintNft, $isMintNft] = useState(filterData?.isMintNft);

  useEffect(() => {
    $rankCode([]);
    $genders([]);
    $breeds([]);
    $tagNFT([]);
    $isMintNft([]);
  }, []);
  useEffect(() => {
    if (breedOptions?.length > 0) {
      const translatedBreeds = breedOptions?.map((breed) => {
        return {
          title:
            breed.groupNameTranslate[propLang] || breed.groupNameTranslate["english"],
          value: breed.collectionGroup,
        };
      });
      $breedOptionLocals(translatedBreeds);
    }
  }, [breedOptions, propLang]);

  useEffect(() => {
    if (rankOptions?.length > 0) {
      const translatedRanks = rankOptions?.map((rank) => {
        return {
          title:
          rank.rankNameTranslate[propLang] || rank.rankNameTranslate["english"],
          value: rank.rankCode,
        };
      });
      $rankOptionLocals(translatedRanks);
    }
  }, [propLang, rankOptions]);

  const onChangeBreed = (val) => {
    const data = val.map((v) => +v);
    $breeds(data);
    setFilterData({
      rankCode,
      breeds: data,
      genders,
      tagNFT,
      priceFrom,
      priceTo,
      isMintNft,
    });
  };

  const onChangeRank = (val) => {
    $rankCode(val);
    setFilterData({
      rankCode: val,
      breeds,
      genders,
      tagNFT,
      priceFrom,
      priceTo,
      isMintNft,
    });
  };
  const onChangeGender = (val) => {
    $genders(val);
    setFilterData({
      rankCode,
      breeds,
      genders: val,
      tagNFT,
      priceFrom,
      priceTo,
      isMintNft,
    });
  };
  const onChangeMint = (val) => {
    $isMintNft(val);
    setFilterData({
      rankCode,
      breeds,
      genders,
      tagNFT,
      priceFrom,
      priceTo,
      isMintNft: val,
    });
  };
  const onChangeTagNFT = (val) => {
    $tagNFT(val);
    setFilterData({
      rankCode,
      breeds,
      genders,
      tagNFT: val,
      priceFrom,
      priceTo,
      isMintNft,
    });
  };
  const onChangePrice = (val) => {
    $priceFrom(val.priceFrom);
    $priceTo(val.priceTo);
    setFilterData({
      rankCode,
      breeds,
      genders,
      tagNFT,
      isMintNft,
      priceFrom: val.priceFrom,
      priceTo: val.priceTo,
    });
  };

  return (
    <div>
      <Price
        title={t("Price")}
        priceFrom={priceFrom}
        priceTo={priceTo}
        onChange={(val) => onChangePrice(val)}
      />
      <CheckboxSimple
        title={t("Collection")}
        name={"breeds"}
        options={breedOptionLocals}
        value={breeds}
        t={t}
        onChange={(val) => onChangeBreed(val)}
      />
      <CheckboxLabel
        title={t("Rank")}
        name={"rankCode"}
        options={rankOptionLocals}
        value={rankCode}
        onChange={(val) => onChangeRank(val)}
      />
      <CheckboxSimple
        title={t("Gender")}
        name={"genders"}
        options={genderOptions}
        value={genders}
        t={t}
        onChange={(val) => onChangeGender(val)}
      />
      <CheckboxLabel
        title={t("NFT")}
        name={"isMintNft"}
        options={isMintNftOptions}
        t={t}
        value={isMintNft}
        onChange={(val) => onChangeMint(val)}
      />
      <CheckboxLabel
        title={t("Art Type")}
        name={"positions"}
        options={artTypeOptions}
        value={tagNFT}
        t={t}
        onChange={(val) => onChangeTagNFT(val)}
      />
    </div>
  );
}

FilterEarner.propTypes = {
  setFilterData: PropTypes.func,
  filterData: PropTypes.object,
  showing: PropTypes.number,
};

export default FilterEarner;
